export default {
  image: {
    type: 'image',
    value: null,
    meta: {
      alt: null,
      redirect_link: null,
    },
  },
  description: {
    type: 'richtext',
    value: null,
    meta: {
      alt: null,
      redirect_link: null,
      border:{
        display: false,
      },
      background:{
        display: false
      }
    },
  },
  audio: {
    type: 'audio',
    value: null,
    meta: {
      alt: null,
      redirect_link: null,
    },
  },
  title: null,
  sub: {
    type: 'translatable-text',
    meta: {
      default_lang: 'vi'
    },
    value: '',
    translations: [
      {
        language: 'vi',
        value: ''
      }
    ]
  },
  spelling: null,
  flip: false
}
